export default {
  data() {
    return {
      userStatus: {
        active: 'ACTIVE'
      },
      currentUser: {}
    }
  },

  computed: {
    isActivateAccount () {
      return this.currentUser && this.currentUser.user &&
        this.currentUser.user.status === this.userStatus.active &&
        this.currentUser.client &&
        this.currentUser.client.is_verified &&
        this.currentUser.client.status === this.userStatus.active
    }
  },

  methods: {
    // e: event object, path: string
    checkPendingAccountStatus (e, path = '') {
      if (!this.isActivateAccount) {
        // stop open modal
        e.stopPropagation()
        this.$notify({
          group: "foo",
          text: this.$lang.messages.account_need_verify_to_do_action,
          type: "error"
        })

        return false
      } else {
        if (path !== '') return this.$router.push({ path })
      }

      return true
    }
  }
}
